const FILE_VERSION = 'MainJs-v1.0';
import { createApp } from 'vue'
import { createPinia } from 'pinia'
import ElementPlus from 'element-plus'
import * as ElementPlusIconsVue from '@element-plus/icons-vue'
import zhCn from 'element-plus/dist/locale/zh-cn.mjs'
import 'element-plus/dist/index.css'
import './style.css'

import App from './App.vue'
import router from './router'

const app = createApp(App)

// 全局错误处理
app.config.errorHandler = (err, instance, info) => {
  console.error('Vue错误:', err)
  console.error('组件:', instance?.$options?.name || instance)
  console.error('信息:', info)
}

// 未捕获的错误处理
window.addEventListener('error', (event) => {
  console.error('全局错误:', event.error)
})

window.addEventListener('unhandledrejection', (event) => {
  console.error('未处理的Promise拒绝:', event.reason)
})

// 注册所有Element Plus图标
for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
  app.component(key, component)
}

app.use(createPinia())
app.use(router)
app.use(ElementPlus, {
  locale: zhCn,
})

// 路由导航错误处理
router.onError((error) => {
  console.error('路由错误:', error)
})

// 路由导航完成后检查
router.afterEach((to, from) => {
  console.log(`[Router] 导航完成: ${from.path} -> ${to.path}`)
  // 检查组件是否正确渲染
  setTimeout(() => {
    const mainContent = document.querySelector('.el-main')
    if (mainContent && mainContent.children.length === 0) {
      console.error('[Router] 警告: 内容区域为空，可能发生白屏')
    }
  }, 100)
})

app.mount('#app')
